import { actionTypes } from "actions/appInfo/actionTypes";

const initState = {
  info: null,
  category: [],
  isSumittingApp: false,
  shouldCloseAppInfo: false,
};

export default (state: any = initState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_APP_INFO_SUCCESS:
      return {
        ...state,
        info: payload,
      };
    case actionTypes.GET_LIST_CATEGORY_SUCCESS:
      return {
        ...state,
        category: payload,
      };
    case actionTypes.SUBMIT_APP:
      return {
        ...state,
        isSumittingApp: true,
      };
    case actionTypes.SUBMIT_APP_SUCCESS:
    case actionTypes.SUBMIT_APP_FAIL:
      return {
        ...state,
        isSumittingApp: false,
      };
    case actionTypes.TOGGLE_APP_INFO_MODAL:
      return {
        ...state,
        shouldCloseAppInfo: payload,
      };
    default:
      return state;
  }
};
